module.exports = "\n<app-history-list *ngIf=\"( type !== TYPE_UPCOMING && type !== TYPE_SCRIPTURES && type !== TYPE_PRAYER_TOPICS ) || type === TYPE_HISTORY\"></app-history-list>\n<app-upcoming-list *ngIf=\"type === TYPE_UPCOMING\"></app-upcoming-list>\n<app-scriptures-list *ngIf=\"type === TYPE_SCRIPTURES\"></app-scriptures-list>\n<app-prayer-topics *ngIf=\"type === TYPE_PRAYER_TOPICS\"></app-prayer-topics>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main